import React, { useState, useCallback } from "react";
import { Upload, Button, Avatar, Modal, Slider } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Cropper from "react-easy-crop";
import useViewportWidth from "../../hooks/useViewportWidth";

export default function PhotoUpload({ resume, updateField }) {
  const viewportWidth = useViewportWidth();
  const isCompact = viewportWidth <= 1024;
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [open, setOpen] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // 🔹 Handle upload (only open modal)
  const onUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageSrc(e.target.result);
      setOpen(true);
    };
    reader.readAsDataURL(file);
    return false;
  };

  // 🔹 Save cropped area
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // 🔹 Generate cropped image
  const getCroppedImg = async (imageSrc, crop) => {
    const image = new Image();
    image.src = imageSrc;

    await new Promise((resolve) => {
      image.onload = resolve;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      image,
      crop.x,
      crop.y,
      crop.width,
      crop.height,
      0,
      0,
      crop.width,
      crop.height
    );

    return canvas.toDataURL("image/jpeg");
  };

  // 🔹 Save final cropped image
  const handleSave = async () => {
    if (!croppedAreaPixels) return;

    const croppedImage = await getCroppedImg(
      imageSrc,
      croppedAreaPixels
    );

    updateField("photo", croppedImage);
    updateField("photoSource", "uploaded");

    setOpen(false);
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 12,
        }}
      >
        <Upload showUploadList={false} beforeUpload={onUpload}>
          <Button icon={<UploadOutlined />}>Upload Photo</Button>
        </Upload>

        {resume?.photo && (
          <Avatar
            src={resume.photo}
            size={70}
            shape="circle"
            style={{
              border: "2px solid #ddd",
              backgroundColor: "#f0f0f0",
              marginLeft: isCompact ? 0 : "1em",
              cursor: "pointer",
            }}
            onClick={() => setOpen(true)}
          />
        )}
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={handleSave}
        width={400}
        title="Adjust Photo"
        okText="Save"
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: 300,
            background: "#000",
          }}
        >
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          Zoom
          <Slider
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={setZoom}
          />
        </div>
      </Modal>
    </div>
  );
}
